<template>
    <div v-if="available">
        <div class="loan-calculator__wrap">
            <h2 v-if="!hasError" class="loan-calculator__headline">{{ dictionary.loanCalculatorHeadline.replace('{modelName}',
                vehicle.ModelName) }}</h2>
                <h2 v-else class="loan-calculator__headline">{{ dictionary.loanCalculatorErrorMessage }}</h2>
                <div v-if="!hasError">
                <p class="loan-calculator__text">{{ dictionary.loanCalculatorText }}</p>
                <div class="formgrid loan-calculator__controls">
                    <div class="field">
                        <label for="downpayment">{{ dictionary.loanCalculatorDownPaymentLabel }}</label>
                        <InputNumber class="p-inputtext-lg" id="downpayment" v-model="downPayment" />
                    </div>
                    <div class="field">
                        <label for="term">{{ dictionary.loanCalculatorTermLabel }}</label>
                        <Dropdown class="p-inputtext-lg" id="term" v-model="term" :options="terms" />
                    </div>
                    <Button class="p-button p-button-primary" @click="recalculateLoans(true,true)">{{
                        dictionary.loanCalculatorCalculateButton }}</Button>
                </div>
                <p class="loan-calculator__correction" v-if="downPaymentCorrected">{{ dictionary.loanCalculatorDownPaymentCorrected }}</p>
                <p class="loan-calculator__correction" v-if="termCorrected">{{ dictionary.loanCalculatorTermCorrected }}</p>
                <div class="loan-calculator__calculations">
                    <div class="loan-calculation" v-for="calculation in loans"
                        :class="{ 'loan-calculation--collapsed-on-mobile': !calculation['showAllInfo'] }">
                        <div class="loan-calculation__header">
                            <h3 v-if="calculation.interestType == 0" class="loan-calculation__headline">{{
                                dictionary.loanCalculatorFixedRateLoanHeadline }}</h3>
                            <h3 v-if="calculation.interestType == 1" class="loan-calculation__headline">{{
                                dictionary.loanCalculatorVariableRateLoanHeadline }}</h3>
    
                            <button class="loan-calculation__info-toggle" type="button"
                                @click.stop="calculation['showAllInfo'] = !(calculation['showAllInfo'])">
                                <span v-if="!(calculation['showAllInfo'])">
                                            Læs mere
                                        </span>
                                        <span v-if="(calculation['showAllInfo'])">
                                            Læs mindre
                                        </span>
                            </button>
    
                        </div>
                        <table class="loan-calculation__table loan-calculation__table--emphasized">
                            <tr>
                                <td>{{ dictionary.loanCalculatorMonthlyPayment }}</td>
                                <td>{{ getLocalNumberString(Math.round(calculation.monthlyPaymentAmount)) }} kr.</td>
                            </tr>
                        </table>
                        <table class="loan-calculation__table">
                            <tr>
                                <td>{{ dictionary.loanCalculatorVehiclePrice }}</td>
                                <td>{{ getLocalNumberString(Math.round(vehicle.Price)) }} kr.</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorDownPayment }}</td>
                                <td>{{ getLocalNumberString(Math.round(calculation.downPayment)) }} kr.</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorTerm }}</td>
                                <td>{{ calculation.term }} mdr.</td>
                            </tr>
                        </table>
                        <div class="loan-calculation__hr"></div>
                        <table class="loan-calculation__table">
                            <tr>
                                <td>{{ dictionary.loanCalculatorCreditCost }}</td>
                                <td>{{ getLocalNumberString(Math.round(calculation.creditCostAmount)) }} kr.</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorTotalRepayment }}</td>
                                <td>{{ getLocalNumberString(Math.round((calculation.totalRepaymentAmount - calculation.downPayment))) }} kr.</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorInterestRate }}</td>
                                <td>{{ getLocalNumberString(calculation.interestRate) }} %</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorInterestRateAnnual }}</td>
                                <td>{{ getLocalNumberString(calculation.interestRateAnnual) }} %</td>
                            </tr>
                            <tr>
                                <td>{{ dictionary.loanCalculatorTotalYearlyCostInPercentage }}</td>
                                <td>{{ getLocalNumberString(calculation.totalYearlyCreditCostInPercentage) }} %</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="!isMinimalVersion" class="loan-calculator__cta">
                <Button class="p-button-secondary loan-calculator__cta-button">Få tilbud tilsendt</Button>
            </div>

            </div>
            
        </div>
        <p class="loan-calculator__disclaimer" v-html="dictionary.loanCalculatorDisclaimer"></p>
    </div>
</template>
<script>
import VueHelpers from './vueHelpers';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';

export default {
    name: "loanCalculator",
    components: {
        InputNumber,
        Button,
        Dropdown
    },
    data() {
        return {
            dictionary: [],
            vehicle: null,
            available: false,
            isLoading: false,
            downPayment: null,
            term: null,
            downPaymentCorrected:false,
            termCorrected:false,
            terms: [120, 108, 96, 84, 72, 60, 48, 36, 24, 12],
            loans: [],
            hasError:false,
            isMinimalVersion:false
        };
    },
    created() {
        const vm = this;
        vm.vehicle = JSON.parse(vm.$parent.vehicle);
        vm.isMinimalVersion = vm.$parent.isMinimalVersion == "True";
        vm.culture = document.querySelector("html").getAttribute("lang");
        if (vm.vehicle.Price > 0) {
            vm.term = vm.terms[0];

            fetch('/umbraco/api/resourcesApi/GetLoanCalculatorDictionary')
            .then(response => response.json())
                .then((data) => {
                    vm.dictionary = data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    vm.available = true;
                });

            vm.recalculateLoans(false,false);

        }
    },
    methods: {
        getLocalNumberString(number) {
            return VueHelpers.getLocalNumberString(number);
        }, 
        recalculateLoans: function (showSpinner = false, setCorrectionFlags = false) {
            const vm = this;
            vm.toggleSpinner(showSpinner);

            vm.loans = [];
            vm.downPaymentCorrected = false;
            vm.termCorrected = false;

            const baseLoanRequestModel = {
                vehicleVin: vm.vehicle.Vin,
                vehiclePrice: vm.vehicle.Price,
                vehicleRegistrationDate: vm.vehicle.RegistrationDate,
                vehicleBrand: vm.vehicle.BrandAlias.replace(' ', ''),
                vehicleFuelType: vm.vehicle.SystemFuelType,
                term: vm.term
            };

            if (vm.downPayment != null) {
                if(vm.downPayment > vm.vehicle.Price) {
                    vm.downPayment = vm.vehicle.Price - 1000;
                }
                baseLoanRequestModel.downPayment = vm.downPayment;
            }

            const variableRateLoanRequestModel = new URLSearchParams(baseLoanRequestModel);
            variableRateLoanRequestModel.append('interestType', 'Variable');

            const fixedRateLoanRequestModel = new URLSearchParams(baseLoanRequestModel);
            fixedRateLoanRequestModel.append('interestType', 'Fixed');

            vm.getLoanCalculation(fixedRateLoanRequestModel, setCorrectionFlags);
            vm.getLoanCalculation(variableRateLoanRequestModel, setCorrectionFlags);
        },
        getLoanCalculation: function (requestModel,setCorrectionFlags = false) {
            const vm = this;
            fetch('/umbraco/api/financialApi/getLoanCalculation?' + requestModel)
            .then((response) => {
                if (response.status == 400) {
                    const error = new Error("");
                    error.status = response.status;
                    throw error;
                }
                return response;
            }).then((response) => response.json())
                .then((data) => {
                    vm.loans.push(data);

                    //We are adjusting the downpayment and term based on the calculated loan
                    vm.downPayment = Math.round(data.downPayment);
                    vm.term = data.term;

                    if(setCorrectionFlags){
                        vm.downPaymentCorrected = data.downPaymentCorrected;
                        vm.termCorrected = data.termCorrected;
                    }

                    vm.toggleSpinner(false);

                })
                .catch((error) => {
                    vm.toggleSpinner(false);
                    vm.hasError = true;
                    console.log(error);

                });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        }
    }
};
</script>
